import api from './api';

// Parâmetros globais do sistema (somente admin). Hoje: alíquota de ISS da NFS-e da plataforma.
export const obterConfiguracaoIss = () =>
    api.get<{ aliquotaIss: number }>('/Empresa/admin/configuracao-iss');

export const definirConfiguracaoIss = (aliquotaIss: number) =>
    api.put('/Empresa/admin/configuracao-iss', { aliquotaIss });
